export class ShadowClass {
  shadow = "";

  constructor(shadowElement) {
    if (shadowElement) {
      this.shadow = shadowElement;
    } else {
      this.shadow = document.querySelector(".shadow");
    }
  }

  init() {
    // this.shadow = document.querySelector(".shadow");s
  }

  toggleShadow() {
    if (!this.shadow.classList.contains("shadow_visible")) {
      this.openShadow();
    } else {
      this.closeShadow();
    }
  }

  openShadow() {
    this.shadow.classList.add("shadow_visible");
    setTimeout(() => {
      this.shadow.classList.add("shadow_opacity-full");
    }, 100);
  }

  closeShadow() {
    this.shadow.classList.remove("shadow_opacity-full");

    setTimeout(() => {
      this.shadow.classList.remove("shadow_visible");
    }, 100);
  }
}
